<div [class.is-sticky]="isSticky()" class="section-wrapper">
  <div class="section-wrapper__content">
    @if (sectionTitle()) {
      <h3 class="section-wrapper__content--title">{{ sectionTitle() }}</h3>
    }
    <ng-content></ng-content>
  </div>
</div>
